export default __webpack_public_path__ + "static/media/DSC_9120-thumb.27dc435d.jpg";